"use client";

import React from "react";
import { ContentResponse } from "../../services/api.response.service";
import WatchSVG from "../../assets/svg/video-ic.svg";
import ReadSVG from "../../assets/svg/read-ic.svg";
import AudioSVG from "../../assets/svg/audio-ic.svg";

export type ContentMediaLang = {
  watch: string;
  listen: string;
  read: string;
};

type ContentMediaBadgesProps = {
  content: ContentResponse;
  isShortForm: boolean;
  lang: ContentMediaLang;
  justifyMain?: "start" | "end";
};

export function ContentMediaBadges({
  content,
  isShortForm,
  lang,
  justifyMain = "end",
}: ContentMediaBadgesProps) {
  const alignClass =
    isShortForm || justifyMain === "start"
      ? "justify-content-start"
      : "justify-content-end";

  return (
    <div
      className={`${alignClass} d-grid d-flex gap-1 flex-wrap`}
      aria-label="Content types"
    >
      {content.total_videos != null && content.total_videos !== 0 && (
        <div className="d-grid d-flex gap-1 mx-1">
          <img
            src={WatchSVG}
            alt=""
            width={14}
            height={14}
            className="mt-1 mx-1 w-14 h-14 justify-content-end"
          />
          <span className="topic-label-fw">
            {isShortForm
              ? `[${content.total_videos}]`
              : `${lang.watch} [${content.total_videos}]`}
          </span>
        </div>
      )}

      {content.total_audios != null && content.total_audios !== 0 && (
        <div className="d-grid d-flex gap-1 mx-1">
          <img
            src={AudioSVG}
            alt=""
            width={14}
            height={14}
            className="mt-1 mx-1 w-14 h-14 justify-content-end"
          />
          <span className="topic-label-fw">
            {isShortForm
              ? `[${content.total_audios}]`
              : `${lang.listen} [${content.total_audios}]`}
          </span>
        </div>
      )}

      {content.has_read && (
        <div className="d-grid d-flex gap-1 mx-1">
          <img
            src={ReadSVG}
            alt=""
            width={14}
            height={14}
            className="mt-1 w-14 h-14 justify-content-end"
          />
          {!isShortForm && <span className="topic-label-fw">{lang.read}</span>}
        </div>
      )}
    </div>
  );
}

export function contentHasMediaBadges(content: ContentResponse): boolean {
  return (
    (content.total_videos != null && content.total_videos !== 0) ||
    (content.total_audios != null && content.total_audios !== 0) ||
    Boolean(content.has_read)
  );
}
